import { render, staticRenderFns } from "./ScantrustProText.vue?vue&type=template&id=7a3ee894"
import script from "./ScantrustProText.vue?vue&type=script&lang=js"
export * from "./ScantrustProText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports